import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';

@Component({
    selector: 'app-bb-self-guided-access-link',
    templateUrl: './bb-self-guided-access-link.component.html',
    styleUrls: ['./bb-self-guided-access-link.component.scss'],
    standalone: false
})
export class BbSelfGuidedAccessLinkComponent {
  
  guid:string=''
  constructor(private route:ActivatedRoute,private _bbinvitationservice:BbInvitationService,private router:Router) { }
  
  ngOnInit(): void 
  {
      this.route.params.subscribe(params=>{
        this.guid=params['guid'];
        this._bbinvitationservice.accessBBSelfGuidedInviteLink(this.guid).subscribe({
          next:(res)=>
            {
              this.router.navigateByUrl('/'+res.redirectTo)
            }
        })
      })
   }
}
